import { jwtDecode } from 'jwt-decode';

import type { Auth0Address } from '~/types/address';
import { type FormattedProfile, type JwtIdToken } from '~/types/auth';
import type { UserMetadata } from '~/types/user';

export function formatAuth0Address(address: Auth0Address) {
  return `${address.street}${
    address.complement ? ' ' + address.complement : ''
  }, ${address.city}, ${address.state} ${address.postalCode}`;
}

function decodeIdToken(idToken: string): JwtIdToken {
  return jwtDecode(idToken);
}

// get the user's profile name or oauth name
export function getUserFullName(userMetadata: UserMetadata): string {
  const { firstName, lastName } = userMetadata;
  return `${firstName} ${lastName}`;
}

export function getUserFromIdToken(idToken?: string): FormattedProfile {
  if (!idToken) return { email: '', picture: '' };
  const userData = decodeIdToken(idToken);
  const { email, picture } = userData;
  return { email, picture };
}
